import { NotificationMethodType } from "../enums/global.enums";

export function notificationMethodPipe(value: string) {
    switch (value) {
        case NotificationMethodType.All: return "Tất cả";
        case NotificationMethodType.App: return "Ứng dụng";
        case NotificationMethodType.Zalo: return "Zalo";
        case NotificationMethodType.Sms: return "SMS";
    }
    return "";
}

export const NOTIFICATION_METHODS = [
    NotificationMethodType.App,
    NotificationMethodType.Zalo,
    NotificationMethodType.Sms
];
